import { render, staticRenderFns } from "./PendingApprovalMerchants.vue?vue&type=template&id=3899a7be&"
import script from "./PendingApprovalMerchants.vue?vue&type=script&lang=js&"
export * from "./PendingApprovalMerchants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports